import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme, createLightTheme, BrandVariants } from "@fluentui/react-components";

/* global document, Office, module, require, HTMLElement */

const title = "Email Classification Add-in";

// Create a custom brand theme with blue colors
const myBrandRamp: BrandVariants = {
  10: "#000509",
  20: "#011221",
  30: "#031D36",
  40: "#042A4F",
  50: "#053666",
  60: "#06437F",
  70: "#074F97",
  80: "#085CB0",
  90: "#0968C8",
  100: "#0A75E1",
  110: "#2182E4",
  120: "#3990E8",
  130: "#509DEB",
  140: "#68AAEF",
  150: "#7FB8F2",
  160: "#97C5F6",
};

const myTheme = createLightTheme(myBrandRamp);

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider theme={myTheme}>
      <App title={title} />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
